export default __webpack_public_path__ + "static/media/G0680.34I-26416_-16234_0.1666267080000.5003e357.jpg";